import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger" | "link";
export type ButtonSize = "sm" | "md";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
}

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary:
    "bg-accent text-white hover:bg-accent-hover disabled:opacity-60 disabled:cursor-not-allowed",
  secondary:
    "border border-input-border bg-card text-text-secondary hover:bg-card-hover hover:text-text-primary disabled:opacity-60 disabled:cursor-not-allowed",
  ghost:
    "text-text-secondary hover:bg-card-hover hover:text-text-primary disabled:opacity-60 disabled:cursor-not-allowed",
  danger: "bg-error text-white hover:bg-error/90 disabled:opacity-60 disabled:cursor-not-allowed",
  link: "text-link hover:text-link-hover underline-offset-2 hover:underline disabled:opacity-60",
};

const SIZE_CLASSES: Record<ButtonSize, string> = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
};

export function Button({
  variant = "primary",
  size = "md",
  className = "",
  type = "button",
  children,
  ...rest
}: ButtonProps) {
  const base =
    variant === "link"
      ? "inline-flex items-center gap-1 transition-colors duration-150 font-medium"
      : `inline-flex items-center gap-2 rounded-md font-medium transition-colors duration-150 ${SIZE_CLASSES[size]}`;

  return (
    <button type={type} className={`${base} ${VARIANT_CLASSES[variant]} ${className}`} {...rest}>
      {children}
    </button>
  );
}
